/* Add your custom JavaScript below this line */
if (window.routes && !window.routes.cart_url) {
  window.routes.cart_url = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'cart';
}
